export class InvalidEmailError extends Error {
  constructor(message?: string) {
    super(message ?? "Email domain is not valid");
    this.name = "InvalidEmailError";
  }
}
